import { render, staticRenderFns } from "./servingCounseling.vue?vue&type=template&id=c56879bc&"
import script from "./servingCounseling.vue?vue&type=script&lang=js&"
export * from "./servingCounseling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports